import { render } from "./CallbackRequests.vue?vue&type=template&id=0fc32b32&scoped=true&ts=true"
import script from "./CallbackRequests.vue?vue&type=script&lang=ts"
export * from "./CallbackRequests.vue?vue&type=script&lang=ts"

import "./CallbackRequests.vue?vue&type=style&index=0&id=0fc32b32&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fc32b32"]])

export default __exports__